import styled from "styled-components"

export const Icon = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.137);
  svg {
    width: 16px;
    height: 16px;
    path {
      fill: #516683;
    }
  }
`
